import { useForm } from "react-hook-form";
import { MainPageTopPanel } from "../../components/topBar/TopBar";
import Expandable from "../../components/widget/Expandable/Expandable";
import { BarContent, MetadataContent } from "./Sites";
import { ProductGeneralContent as DirectorContent } from "./SiteProduct";
import { directorGenURL, directorMetaURL } from "../../utils/endpoint";
import { connect } from "react-redux";
import { getAction } from "../../store/actions/creators/request.actions";
import { useEffect } from "react";
import { GET_SITE_GENERAL, GET_SITE_META } from "../../store/actions/action_types/action.types";

const ExpandableContent = [
  {
    name: "Metadata (SEO)",
    Component: props => <MetadataContent {...props} url={directorMetaURL} />,
  },
  { name: "General", Component: props => <DirectorContent {...props} url={directorGenURL} /> },
];

const SiteDirectors = ({ token, ...props }) => {
  const { handleSubmit, ...formData } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    props.getAction(GET_SITE_META, directorMetaURL, token);
    props.getAction(GET_SITE_GENERAL, directorGenURL, token);
  }, []);

  const submitForm = data => {
    alert(JSON.stringify(data));
  };

  const checkKeyDown = e => {
    if (e.code === "Enter") e.preventDefault();
  };
  return (
    <div className="">
      <MainPageTopPanel btnName="Publish" content={<BarContent name="Board of Directors" />} />
      {ExpandableContent.map(({ Component, ...content }) => (
        <Expandable
          {...content}
          component={<Component data={props} checkKeyDown={checkKeyDown} />}
          showToggle={content.hasToggle}
          hasCount={content.hasCount}
          modalcontent={content.modalcontent}
          hasPlus={content.hasPlus}
          loading={props.meta_loading}
        />
      ))}
    </div>
  );
};
const mapStateToProps = state => ({
  token: state.auth.login.token,
  meta_data: state.site.main.get_site_meta.data,
  meta_loading: state.site.main.get_site_meta.loading,
  general_data: state.site.main.get_site_general.data,
});
export default connect(mapStateToProps, { getAction })(SiteDirectors);
